import { estyled } from './estyled'

export * from './estyled'

export default estyled
